import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import * as jnb from 'react-bootstrap';
import { VscDiffAdded } from 'react-icons/vsc';
import { FaRegEdit, FaSave } from 'react-icons/fa';
import Sweetalert from '../../../CommonUtils/CommonPopupAndAlerts/SweetAlerts';
import { config } from '../../../CommonUtils/CommonUrl/CommonUrls';
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtils/CommonAxios/CommonAxios';
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { useSelector } from 'react-redux';
import axios from 'axios';
import { public_url } from '../../../CommonUtils/Validations/RegularExpAndVar';
import Header from '../../../Header/Header';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { NumberOfDaysBtToday, NumberSpellingConverter } from '../../../CommonUtils/CommonFunctions/NumberSpellingConverter';
import Select from 'react-select';
import { InWardChequeValidation } from '../../../CommonUtils/Validations/Validations';

export default function InWardChequeIn() {
    var moment = require('moment');
    const loginreducer = useSelector((state) => state?.reducers?.loginreducer?.loginDetails?.loginData);
    const [showList, setList] = useState([]);
    let formetDate = moment().format('YYYY-MM-DD');
    const [showIndex, setIndex] = useState(null)
    const [showValue, setValue] = useState(formetDate)
    const Formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            entry_by: loginreducer?.username,
            incharge_cfms_id: loginreducer?.username,
            in_ward_cheque_in_date: showValue,
            organisation_name: "",
            lr_no_and_date: "",
            dept: "",
            work_executed_at_district: "",
            date_of_recieving: "",
            by_dept: "",
            name_of_bank: "",
            branch: "",
            dd_cheque: "",
            cheque_no_or_ddno: "",
            date: "",
            amount: "",
            current_no: "",
            office_name: "",
            from_district: "",
            lr_no: "",
        },
        onSubmit: (values, { resetForm }) => {
            const convertedAmount = NumberSpellingConverter({ value: values?.amount })
            let showValidCheck = "";
            const daysDifference = NumberOfDaysBtToday({ value: values?.date })
            if (daysDifference >= 90) {
                showValidCheck = "The Check you Entered May Expired";
            }
            Swal.fire({
                //title: "Are you sure want to submit?",
                // text: <div><h1> You have entered amount of <br /></h1>
                // </div>,
                html: `<div><p>You have entered an amount of 
                <b style="color: brown;text-transform: uppercase;">${convertedAmount} Rupees</b><br/>
                ${showValidCheck}
               
                </p></div>`,
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#198754",
                cancelButtonColor: "#3085d6",
                cancelButtonText: "Edit",
                confirmButtonText: "Proceed",

                customClass: {
                    title: 'swal-title',
                    confirmButton: 'swal-space-between-buttons',
                    cancelButton: 'swal-space-between-buttons'
                }
            }).then((save) => {
                if (save.isConfirmed) {
                    let url = config.url.BOC_URL + "cheque-dd-inward-register";
                    CommonAxiosPost(url, values).then((res) => {
                        if (res?.data?.scode === '01') {
                            values.current_no = res?.data?.current_no;
                            if (showIndex !== null) {
                                setList((prevList) => {
                                    let newList = prevList.map((item, currentIndex) =>
                                        currentIndex === showIndex ? values : item
                                    );
                                    return newList;
                                });
                            } else {
                                setList((prevList) => [...prevList, values]);
                            }
                            resetForm()
                            setIndex(null)
                        }
                        else if (res.data.scode === '02') {
                            Sweetalert(res.data.sdesc, 'warning')
                        }
                        else if (res.data.scode === '03') {
                            Sweetalert("Enter valid details", "warning")

                        }
                    })
                }
            })

            //console.log("values", JSON.stringify(values));
        },
      validationSchema: InWardChequeValidation
    })
    const [officeList, setOfficeList] = useState([])
    function GetOffices(e) {
        let url = config.url.BOC_URL + "alo-offices";
        CommonAxiosGet(url).then((response) => {
            if (response.data.status === true) {
      //console.log("val>>",response.data?.offices?.filter((val)=>val.lgd_dist_code == e.target.value))
                setOfficeList(response.data?.offices?.filter((val)=>val.lgd_dist_code === parseInt(e.target.value)));

            }
            else {

                setOfficeList([])
            }
        })
    }
    function EditOptions(item) {
        Formik.setFieldValue("organisation_name", item.organisation_name)
        Formik.setFieldValue("lr_no_and_date", item.lr_no_and_date)
        Formik.setFieldValue("dept", item.dept)
        Formik.setFieldValue("work_executed_at_district", item.work_executed_at_district)
        Formik.setFieldValue("date_of_recieving", item.date_of_recieving)
        Formik.setFieldValue("by_dept", item.by_dept)
        Formik.setFieldValue("name_of_bank", item.name_of_bank)
        Formik.setFieldValue("branch", item.branch)
        Formik.setFieldValue("dd_cheque", item.dd_cheque)
        Formik.setFieldValue("cheque_no_or_ddno", item.cheque_no_or_ddno)
        Formik.setFieldValue("date", item.date)
        Formik.setFieldValue("amount", item.amount)
        Formik.setFieldValue("in_ward_cheque_in_date", item.in_ward_cheque_in_date)
        Formik.setFieldValue("current_no", item.current_no)
        Formik.setFieldValue("office_name", item.office_name)
        Formik.setFieldValue("lr_no", item.lr_no)
        Formik.setFieldValue("from_district", item.from_district)

    }

    const [showConfirmStatus, setconfirmStatus] = useState(null)
    function GetChequeInReport() {
        let url = config.url.BOC_URL + "cheque-dd-inward-register?incharge_cfms_id=" + loginreducer?.username + "&in_ward_cheque_in_date=" + showValue;
        CommonAxiosGet(url).then((response) => {
            if (response.data.status === true) {
                setList(response.data.details);
                setconfirmStatus(response?.data?.details[0]?.is_incharge_confirmed)
            }
            else {
                setconfirmStatus(null)
                setList([])
            }
        })
    }
    function GetChequeReport(e) {
        setValue(e.target.value)
        Formik.setFieldValue("in_ward_cheque_in_date",showValue)
        let url = config.url.BOC_URL + "cheque-dd-inward-register?incharge_cfms_id=" + loginreducer?.username + "&in_ward_cheque_in_date=" + e.target.value;
        CommonAxiosGet(url).then((response) => {
            if (response.data.status === true) {
                setList(response.data.details);
                setconfirmStatus(response?.data?.details[0]?.is_incharge_confirmed)
            }
            else {
                setconfirmStatus(null)
                setList([])
            }
        })
    }
    function SaveOptions() {
        let url = config.url.BOC_URL + "inward-cheque-in-date-confirmation"; // finalsave
        let msg = "once submitted for the day,you cannot add any cheque or dd for the day";
        let data = {
            entry_by: loginreducer?.username,
            in_ward_cheque_in_date: showValue,
            incharge_cfms_id: loginreducer?.username,
        }
        Swal.fire({
            title: "Are you sure ?",
            text: msg,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
            cancelButtonText: "No"
        }).then((save) => {
            if (save.isConfirmed) {
                CommonAxiosPost(url, data).then((res) => {
                    if (res?.data?.scode === '01') {
                        Sweetalert("Successfully Submitted", 'success')
                        GetChequeInReport()
                    }
                    else if (res.data.scode === '02') {
                        Sweetalert(res.data.sdesc, 'warning')
                    }

                })
            }
        })

    }
    /************************************************** Districts for all  ************************************ ******* */
    const [showDist, setDist] = useState([])
    const getDistDataFunction = () => {
        let url = config.url.BOC_URL + public_url + "listofstates";
        axios.get(url).then((response) => {
            setDist(response.data.districts);
        })
    };
    const today = moment().format('YYYY-MM-DD');
    const dayBeforeYesterday = moment().subtract(2, 'days').format('YYYY-MM-DD');
    let navigate = useNavigate()

    useEffect(() => {
        GetChequeInReport()
        getDistDataFunction()

    }, [])
    return (
        <React.Fragment>
            <Header />
            <div className="main_section"> </div>
            <FormikProvider value={Formik}>
                <jnb.Form onChange={Formik.handleChange} onSubmit={Formik.handleSubmit} className="form_adjust">
                    <jnb.Container className="mt-0">
                        <jnb.Row className="page-titlespacing d-flex justify-content-between px-0" >
                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={4} xxl={4} >
                                <div className="inner-herbpage-service-title1">
                                    <h1>Inward Cheque In Date -</h1>
                                </div>
                            </jnb.Col>
                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={2} xxl={2} className='mt-2'>

                                <Field type="date"
                                    className="form-control"
                                    min={dayBeforeYesterday}
                                    max={today}
                                    onChange={(e) => { GetChequeReport(e) }}

                                    name="in_ward_cheque_in_date" />
                                <ErrorMessage name="in_ward_cheque_in_date" component="div" className="text-error" />
                            </jnb.Col>
                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={5} xxl={5} ></jnb.Col>
                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={1} xxl={1} >
                                <div className="text-right">
                                    <button type="button" className="btn btn-secondary btn-sm" onClick={() => { navigate(-1) }}>Back</button>
                                </div>
                            </jnb.Col>
                        </jnb.Row>
                    </jnb.Container>
                {/* </jnb.Form>
            </FormikProvider> */}
                               <jnb.Container className="outer-page-content-container" >

                        <div className="form-card-jnb" >

                            {showConfirmStatus === true ? <></> : <React.Fragment>
                                <jnb.Row className="pt-0">
                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={2} xxl={2} >
                                        <jnb.InputGroup className="">
                                            <label>From : </label>
                                            <Field as="select" className="form-control w-100 mt-1" name="by_dept" >
                                                <option value="0">--select--</option>
                                                <option value="labour">Labour DEPT.</option>
                                                <option value="other">Other Gov. DEPT.</option>
                                                <option value="ext">External</option>

                                            </Field>
                                            <ErrorMessage name="by_dept" component="div" className="text-error" />
                                        </jnb.InputGroup>
                                    </jnb.Col>
                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={2} xxl={2} >
                                        <jnb.InputGroup className="">
                                            <label>District</label>
                                            <Field as="select" className="form-control w-100 mt-1" name="from_district" onChange={(e)=>{GetOffices(e)}} >
                                                <option value="">--Select--</option>
                                                {showDist !== undefined && showDist.map((ds, i) => {
                                                    return (<option key={i} value={ds.districtId}>{ds.distName}</option>);
                                                })}

                                            </Field>
                                            <ErrorMessage name="from_district" component="div" className="text-error" />
                                        </jnb.InputGroup>
                                    </jnb.Col>
                                    {
                                        Formik?.values?.by_dept === "labour" ?
                                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={2} xxl={2} >
                                                <jnb.InputGroup className="">
                                                    <label>Office Name : </label>
                                                    <Select className=" w-100 mt-1"
                                                        name="office_name"
                                                        // getOptionLabel={option => option.org_name}
                                                        // getOptionValue={option => option.org_name}
                                                       // value={officeList?.find(it => it?.org_name == Formik?.values?.office_name) || null}
                                                      options={officeList?.map((fruit) => ({ value: fruit?.org_name, label: fruit?.org_name }))}
                                                       onChange={(option) =>
                                                       {
                                                        //console.log("options>>",option?.label,typeof(option))
                                                        Formik.setFieldValue("office_name", option?.label)
                                                       }
                                                        
                                                        }
                                                        isSearchable={true} isClearable={true}
                                                    />
                                                    <ErrorMessage name="office_name" component="div" className="text-error" />
                                                </jnb.InputGroup>
                                            </jnb.Col> :
                                            Formik?.values?.by_dept === "other" || Formik?.values?.by_dept === "ext" ?
                                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={2} xxl={2} >
                                                    <jnb.InputGroup className="">
                                                        <label>Office Name : </label>
                                                        <Field type="text" className="form-control w-100 mt-1" name="office_name" />


                                                        <ErrorMessage name="office_name" component="div" className="text-error" />
                                                    </jnb.InputGroup>
                                                </jnb.Col> : <></>
                                    }
                                </jnb.Row>
                                <jnb.Row className="pt-0">
                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={2} xxl={2} >
                                        <jnb.InputGroup className="">
                                            <label>Name Of The Organisation</label>
                                            <Field type="text" className="form-control w-100 mt-1" name="organisation_name" />
                                            <ErrorMessage name="organisation_name" component="div" className="text-error" />
                                        </jnb.InputGroup>
                                    </jnb.Col>
                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={2} xxl={2} >
                                        <jnb.InputGroup className="">
                                            <label>LR. No.</label>
                                            <Field type="text" className="form-control w-100 mt-1" name="lr_no" />
                                            <ErrorMessage name="lr_no" component="div" className="text-error" />
                                        </jnb.InputGroup>
                                    </jnb.Col>
                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={2} xxl={2} >
                                        <jnb.InputGroup className="">
                                            <label>LR.Date</label>
                                            <Field type="date" className="form-control w-100 mt-1" name="lr_no_and_date" />
                                            <ErrorMessage name="lr_no_and_date" component="div" className="text-error" />
                                        </jnb.InputGroup>
                                    </jnb.Col>

                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={2} xxl={2} >
                                        <jnb.InputGroup className="">
                                            <label>Dept</label>
                                            <Field as="select" className="form-control w-100 mt-1" name="dept" >
                                                <option value="">--select--</option>
                                                <option value="state">State Govt</option>
                                                <option value="central">Central Govt</option>
                                                <option value="Pvt">Pvt</option>

                                            </Field>
                                            <ErrorMessage name="dept" component="div" className="text-error" />
                                        </jnb.InputGroup>
                                    </jnb.Col>
                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={2} xxl={2} >
                                        <jnb.InputGroup className="">
                                            <label>Work Executed at (District)</label>
                                            <Field as="select" className="form-control w-100 mt-1" name="work_executed_at_district" >
                                                <option value="">--Select--</option>
                                                {showDist !== undefined && showDist.map((ds, i) => {
                                                    return (<option key={i} value={ds.districtId}>{ds.distName}</option>);
                                                })}

                                            </Field>
                                            <ErrorMessage name="work_executed_at_district" component="div" className="text-error" />
                                        </jnb.InputGroup>
                                    </jnb.Col>

                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={2} xxl={2} >
                                        <jnb.InputGroup className="">
                                            <label>Date of Recieving</label>
                                            <Field type="date" className="form-control w-100 mt-1" name="date_of_recieving" />
                                            <ErrorMessage name="date_of_recieving" component="div" className="text-error" />
                                        </jnb.InputGroup>
                                    </jnb.Col>

                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={2} xxl={2} >
                                        <jnb.InputGroup className="">
                                            <label>Name of Bank</label>
                                            <Field type="text" className="form-control w-100 mt-1" name="name_of_bank" />
                                            <ErrorMessage name="name_of_bank" component="div" className="text-error" />
                                        </jnb.InputGroup>
                                    </jnb.Col>
                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={2} xxl={2} >
                                        <jnb.InputGroup className="">
                                            <label>Branch</label>
                                            <Field type="text" className="form-control w-100 mt-1" name="branch" />

                                            <ErrorMessage name="branch" component="div" className="text-error" />
                                        </jnb.InputGroup>
                                    </jnb.Col>
                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={2} xxl={2} >
                                        <jnb.InputGroup className="">
                                            <label>DD /Cheque/Challana</label>
                                            <Field as="select" className="form-control w-100 mt-1" name="dd_cheque" >
                                                <option value="">--select--</option>
                                                <option value="DD">DD</option>
                                                <option value="Cheque">Cheque</option>
                                                <option value="Challana">Challana</option>

                                            </Field>
                                            <ErrorMessage name="dd_cheque" component="div" className="text-error" />
                                        </jnb.InputGroup>
                                    </jnb.Col>
                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={2} xxl={2} >
                                        <jnb.InputGroup className="">
                                            <label>{Formik?.values?.dd_cheque === "" ? "DD" : Formik?.values?.dd_cheque} No.</label>
                                            <Field type="text" className="form-control w-100 mt-1" name="cheque_no_or_ddno" />
                                            <ErrorMessage name="cheque_no_or_ddno" component="div" className="text-error" />
                                        </jnb.InputGroup>
                                    </jnb.Col>
                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={2} xxl={2} >
                                        <jnb.InputGroup className="">
                                            <label>{Formik?.values?.dd_cheque === "" ? "DD" : Formik?.values?.dd_cheque} Date</label>
                                            <Field type="date" className="form-control w-100 mt-1" name="date" />
                                            <ErrorMessage name="date" component="div" className="text-error" />
                                        </jnb.InputGroup>
                                    </jnb.Col>
                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={2} xxl={2} >
                                        <jnb.InputGroup className="">
                                            <label>Amount</label>
                                            <Field type="text" className="form-control w-100 mt-1" name="amount" />
                                            <ErrorMessage name="amount" component="div" className="text-error" />
                                        </jnb.InputGroup>
                                    </jnb.Col>
                                </jnb.Row>
                                <div className='text-end mt-2'>
                                    <button type="submit" className="btn btn-success btn-md"> <VscDiffAdded /> ADD </button>
                                </div>
                            </React.Fragment>}

                            <jnb.Row className="pt-1">
                                <div className="inner-herbpage-service-title-sub">
                                    <h1>Day wise Inward Cheque-In Report</h1>
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-1"
                                        style={{ border: '2px solid lightblue', width: '100%', borderCollapse: 'collapse', }}
                                    >
                                        <thead>
                                            <tr>
                                                <th>S.NO</th>
                                                <th>From</th>
                                                <th>District</th>
                                                <th>Office</th>
                                                <th>Organisation Name</th>
                                                <th>LR No</th>
                                                <th>LR Date</th>
                                                <th >Dept </th>
                                                <th >Work Executed at</th>
                                                <th>Date of Recieving</th>

                                                <th>Name of Bank</th>
                                                <th>Branch</th>
                                                <th>DD/Cheque</th>
                                                <th>cheque/DD/Challana No.</th>
                                                <th>Date</th>
                                                <th>Amount</th>
                                                <th>Edit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {showList.map((item, index) => (
                                                <tr key={index}>                            
                                                    <td>{index + 1}</td>
                                                    <td>{item.by_dept}</td>
                                                    <td>
                                                        {showDist?.filter((val => parseInt(val.districtId) == item.from_district))[0]?.distName}
                                                    </td>
                                                    <td>{item.office_name}</td>
                                                    <td>{item.organisation_name}</td>
                                                    <td>{item.lr_no}</td>
                                                    <td>{item.lr_no_and_date}</td>
                                                    <td>{item.dept}</td>
                                                    <td>
                                                        {showDist?.filter((val => parseInt(val.districtId) == item.work_executed_at_district))[0]?.distName}
                                                    </td>
                                                    <td>{item.date_of_recieving}</td>
                                                    <td>{item.name_of_bank}</td>
                                                    <td>{item.branch}</td>
                                                    <td>{item.dd_cheque}</td>
                                                    <td>{item.cheque_no_or_ddno}</td>
                                                    <td>{item.date}</td>
                                                    <td>{item.amount}</td>
                                                    <td>
                                                        {item.is_incharge_confirmed === true ? <>

                                                            <span style={{ color: "green" }}><IoMdCheckmarkCircleOutline size={35} /> </span>
                                                        </> : <>
                                                            <button type="button" onClick={() => { EditOptions(item); setIndex(index) }} className="btn btn-primary btn-md"> <FaRegEdit /> </button>
                                                        </>}
                                                    </td>

                                                </tr>
                                            ))}

                                        </tbody>
                                    </table>
                                    {showConfirmStatus === true ? <></> :
                                        <div className='text-end mt-2'>
                                            <button type="button" onClick={() => { SaveOptions() }} className="btn btn-success btn-md"><FaSave /> Submit for the day</button>
                                        </div>}
                                </div>

                            </jnb.Row>
                        </div>
                    </jnb.Container>
                </jnb.Form>
            </FormikProvider>

        </React.Fragment>

    )
}
